<template>
    <div>
        <div
            v-for="(x, index) in items"
            :key="`row-${index}`"
            class="input-group"
            style="margin-bottom: 5px;"
        >
            <div class="input-group-prepend">
                <label class="input-group-text" :for="`device-${index}`">ALVI</label>
            </div>
            <input
                type="text"
                name="device[]"
                class="form-control"
                :id="`device-${index}`"
                v-model="items[index]"
            />
            <div class="input-group-append">
                <a
                    href="#" class="btn btn-sm btn-secondary"
                    style="padding-top: 9px;"
                    @click.prevent="removeItem(index)">
                    Remove
                </a>
            </div>
        </div>

        <div class="float-right">
            <a
                href="#"
                @click.prevent="items.push(undefined)"
                class="btn btn-secondary"
            >Add Device</a>
        </div>
    </div>
</template>

<script>
export default {
  name: 'MultiInput',

  props: {
    values: {
      type: Array,
      required: false,
      default: () => (['']),
    },
  },

  created() {
    if (this.values.length > 0) {
      this.items = [
        ...this.values,
      ];
    }
  },

  data: () => ({
    items: [''],
  }),

  computed: {
    total() {
      return this.items.length;
    },
  },

  methods: {
    removeItem(item) {
      this.items.splice(item, 1);

      if (this.total === 0) {
        this.items.push(undefined);
      }
    },

  },

};
</script>

<style scoped>

</style>
